import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const GenericNoContentDueToFilteringError = ({
  headingI18n,
  subtitleI18n,
  resetLink,
  onReset
}) => /*#__PURE__*/_jsx(UIErrorMessage, {
  className: "no-content-error",
  "data-test-id": "no-content-error",
  illustration: "empty-state-charts",
  title: /*#__PURE__*/_jsx("h4", {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `academyErrors.filters.${headingI18n}`
    })
  }),
  children: /*#__PURE__*/_jsxs("p", {
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: `academyErrors.filters.common.${subtitleI18n}`
    }), /*#__PURE__*/_jsx("br", {}), resetLink && /*#__PURE__*/_jsx(UIRouterLink, {
      "data-test-id": "clear-all-filters",
      onClick: onReset,
      to: resetLink,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyErrors.filters.common.clearFilters"
      })
    })]
  })
});
export default GenericNoContentDueToFilteringError;